module.exports = "/static/assets/7838388419a0268456642d4a08fcf5b9.gif";